module.exports = __webpack_public_path__ + "static/flooring-contractor-60d64c71371622ab1d9a27be051c8cd1.jpg";